import Vue from 'vue';

const retrieveIpStatus = () => Vue.axios.get('https://api.ipdata.co', {
  params: {
    'api-key': process.env.VUE_APP_IPDATA_API_KEY,
  },
});

export default {
  retrieveIpStatus,
};
